import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext } from "react";

import {
  Context,
  fetchCareerLatestSheet,
  fetchCareerFeedbackSheets,
  fetchCareerFeedbackQuestions,
  createCareerSheets,
} from "../../../store/student";
import LoginHeader from "../../../organisms/LoginHeader";
import CareerReference from "../../../templates/CareerReference";
import styles from "../common.module.scss";

const CareerReferencePage = () => {
  const { dispatch } = useContext(Context);

  useIonViewWillEnter(() => {
    dispatch(fetchCareerLatestSheet());
    dispatch(fetchCareerFeedbackSheets());
    dispatch(fetchCareerFeedbackQuestions());
  });

  const createCareerSheetsFunc = () => {
    dispatch(createCareerSheets());
  };

  return (
    <IonPage>
      <LoginHeader title="キャリア開拓モード" unreadNotiCount={0} />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <CareerReference createCareerSheets={createCareerSheetsFunc} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CareerReferencePage;
